import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import callApi, { abortableCallApi, callDownload } from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';

// Actions
export const FETCH_CLAIMS = 'FETCH_CLAIMS';
export const FETCH_CLAIMS_SUCCESS = 'FETCH_CLAIMS_SUCCESS';
export const FETCH_CLAIMS_FAIL = 'FETCH_CLAIMS_FAIL';
export const CLEAR_CLAIMS = 'CLEAR_CLAIMS';
export const REFRESH_CLAIM_STATUS = 'REFRESH_CLAIM_STATUS';
export const REFRESH_CLAIM_STATUS_SUCCESS = 'REFRESH_CLAIM_STATUS_SUCCESS';
export const REFRESH_CLAIM_STATUS_FAIL = 'REFRESH_CLAIM_STATUS_FAIL';
export const DOWNLOAD_EXPLAIN_CLAIM = 'DOWNLOAD_EXPLAIN_CLAIM';
export const FETCH_CLAIM_ATTACHMENT_STATUS = 'FETCH_CLAIM_ATTACHMENT_STATUS';
export const FETCH_CLAIM_ATTACHMENT_STATUS_SUCCESS = 'FETCH_CLAIM_ATTACHMENT_STATUS_SUCCESS';
export const FETCH_CLAIM_ATTACHMENT_STATUS_FAIL = 'FETCH_CLAIM_ATTACHMENT_STATUS_FAIL';
export const LOAD_CLAIM_ERA = 'LOAD_CLAIM_ERA';

// Reducer
export default function claimsReducer(state = {
  data: [], count: 0, loading: 0, contextFiltersOptions: null,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_CLAIMS:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_CLAIMS_SUCCESS: {
      const nextData = payload.push
        ? [
          ...state.data.slice(0, state.data.length),
          ...payload.data.slice(0, payload.data.length),
        ]
        : payload.data;
      return {
        ...state,
        ...payload,
        data: nextData,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
        ...payload.contextFiltersOptions ? {
          contextFiltersOptions: {
            orderStatuses: payload.contextFiltersOptions['Order Line Workflow Status ID']
              ? Object.keys(payload.contextFiltersOptions['Order Line Workflow Status ID'])
                .map(key => ({
                  name: payload.contextFiltersOptions['Order Line Workflow Status ID'][key].workflow_status_name,
                  ID: Number(key),
                  count: payload.contextFiltersOptions['Order Line Workflow Status ID'][key].count,
                }))
              : Object.keys(payload.contextFiltersOptions['Order Status ID'])
                .map(key => ({
                  name: payload.contextFiltersOptions['Order Status ID'][key].name,
                  ID: Number(key),
                  count: payload.contextFiltersOptions['Order Status ID'][key].count,
                })),
            insurances: Object.keys(payload.contextFiltersOptions['Insurance Info ID'])
              .filter(key => key !== 'null')
              .map(key => ({
                'Payer Name': key !== 'null'
                  ? payload.contextFiltersOptions['Insurance Info ID'][key].payer_name || payload.contextFiltersOptions['Insurance Info ID'][key].insurance_info_name
                  : 'Self Payer',
                ID: Number(key),
                count: payload.contextFiltersOptions['Insurance Info ID'][key].count,
              })),
            claimStatuses: payload.contextFiltersOptions['Claim Status ID']
              ? Object.keys(payload.contextFiltersOptions['Claim Status ID'])
                .map(key => ({
                  name: payload.contextFiltersOptions['Claim Status ID'][key].claim_status_name, count: payload.contextFiltersOptions['Claim Status ID'][key].count,
                }))
              : Object.keys(payload.contextFiltersOptions['Claim Status'])
                .map(key => ({
                  name: key, count: payload.contextFiltersOptions['Claim Status'][key].count,
                })),
            checkNumbers: Object.keys(payload.contextFiltersOptions['Check Book Number'])
                .map(key => ({
                  name: key,
                  ID: Number(key),
                  count: payload.contextFiltersOptions['Check Book Number'][key].count,
                })),
          } } : {},
      };
    }
    case FETCH_CLAIMS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_CLAIMS:
      return {
        ...state,
        data: [],
        count: 0,
      };
    case REFRESH_CLAIM_STATUS_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem.ID !== payload.ID) {
          return dataItem;
        }
        return {
          ...dataItem,
          ...payload,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case FETCH_CLAIM_ATTACHMENT_STATUS_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        const newAttachment = dataItem.Attachment.map(attachmentItem => ({
          ...attachmentItem,
          ...attachmentItem.Extra
            && attachmentItem.Extra.response
            && attachmentItem.Extra.response.attachmentId
            && attachmentItem.Extra.response.attachmentId === payload.Extra.trace_id ? {
              Status: payload,
            } : {},
        }));
        return {
          ...dataItem,
          Attachment: newAttachment,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchClaims(payload) {
  return { type: FETCH_CLAIMS, payload };
}

export function fetchClaimsSuccess(payload) {
  return { type: FETCH_CLAIMS_SUCCESS, payload };
}

export function fetchClaimsFail(payload) {
  return { type: FETCH_CLAIMS_FAIL, payload };
}

export function clearClaims(payload) {
  return { type: CLEAR_CLAIMS, payload };
}

export function refreshClaimStatus(payload) {
  return { type: REFRESH_CLAIM_STATUS, payload };
}

export function refreshClaimStatusSuccess(payload) {
  return { type: REFRESH_CLAIM_STATUS_SUCCESS, payload };
}

export function refreshClaimStatusFail(payload) {
  return { type: REFRESH_CLAIM_STATUS_FAIL, payload };
}

export function downloadExplainClaim(payload) {
  return { type: DOWNLOAD_EXPLAIN_CLAIM, payload };
}

export function fetchClaimAttachmentStatus(payload) {
  return { type: FETCH_CLAIM_ATTACHMENT_STATUS, payload };
}

export function fetchClaimAttachmentStatusSuccess(payload) {
  return { type: FETCH_CLAIM_ATTACHMENT_STATUS_SUCCESS, payload };
}

export function fetchClaimAttachmentStatusFail(payload) {
  return { type: FETCH_CLAIM_ATTACHMENT_STATUS_FAIL, payload };
}

export function loadClaimEra(payload) {
  return { type: LOAD_CLAIM_ERA, payload };
}

// Requests

let abort;

export function requestFetchClaims({ limit, offset }) {
  return callApi(`claim_md/claims/?limit=${limit}&offset=${offset}`);
}

export function requestSearchClaims({ limit, offset, filters, sortBy }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi('claim_md/claims/search/', 'POST', {
    filters: filters || [],
    sort_by: [
      ...sortBy || [],
      {
        name: 'ID',
        sort: 'asc',
      },
    ],
    limit,
    offset,
  });
  abort = request.abort;
  return request.res;
}

export function requestFetchChangeClaims({ limit, offset }) {
  return callApi(`change/claims/?limit=${limit}&offset=${offset}`);
}

export function requestSearchChangeClaims({ limit, offset, filters, sortBy }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi('change/claims/search/', 'POST', {
    filters: filters || [],
    sort_by: [
      ...sortBy || [],
      {
        name: 'ID',
        sort: 'asc',
      },
    ],
    limit,
    offset,
  });
  abort = request.abort;
  return request.res;
}

export function requestRefreshClaimStatus(values) {
  return callApi('claim_md/claim_status/', 'POST', {
    'Claim ID': values['Claim ID'],
  });
}

export function requestDownloadExplainClaim(payload) {
  if (payload.full) {
    return callDownload(`claim_md/claims/explain/?ID=${payload.ID}&LEVEL=full`, 'GET', payload.fileName);
  }
  return callDownload(`claim_md/claims/explain/?ID=${payload.ID}`, 'GET', payload.fileName);
}

export function requestFetchClaimAttachmentStatus(values) {
  return callApi('claim_md/attachment_statuses/', 'POST', {
    'Trace ID': values['Trace ID'],
  });
}

export function requestLoadClaimEra(payload) {
  return callApi('claim_md/era_controller/', 'POST', payload);
}

// Sagas
function* fetchClaimsSaga(action) {
  const { triggerLoading, variant } = action.payload;
  try {
    let res;
    if (variant === 'change') {
      res = yield call(requestSearchChangeClaims, action.payload);
    } else {
      res = yield call(requestSearchClaims, action.payload);
    }
    yield put(fetchClaimsSuccess({
      data: res.data,
      count: res.count,
      contextFiltersOptions: res.next_filter_data || null,
      triggerLoading,
      ...action.payload.push ? { push: true } : {},
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchClaimsFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* refreshClaimStatusSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestRefreshClaimStatus, values);
    yield put(refreshClaimStatusSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(refreshClaimStatusFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* downloadExplainClaimSaga(action) {
  try {
    yield call(requestDownloadExplainClaim, action.payload);
  } catch (err) {
    yield put(addNotification({
      message: 'Failed to Download Claim Details',
      variant: 'warning',
    }));
  }
}

function* fetchClaimAttachmentStatusSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestFetchClaimAttachmentStatus, values);
    yield put(fetchClaimAttachmentStatusSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(fetchClaimAttachmentStatusFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* loadClaimERASaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestLoadClaimEra, values);
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    if (reject) {
      reject(err.data);
    }
  }
}

export function* claimsSaga() {
  yield takeLatest(FETCH_CLAIMS, fetchClaimsSaga);
  yield takeEvery(REFRESH_CLAIM_STATUS, refreshClaimStatusSaga);
  yield takeEvery(DOWNLOAD_EXPLAIN_CLAIM,
    downloadExplainClaimSaga);
  yield takeEvery(FETCH_CLAIM_ATTACHMENT_STATUS, fetchClaimAttachmentStatusSaga);
  yield takeEvery(LOAD_CLAIM_ERA, loadClaimERASaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/claims.js